<syn-avatar
    matIco="bug-outline"
    [size]="size"
    [tooltip]="title"
    [text]="text"
    [caption]="caption"
    [backgroundColor]="backgroundColor"
    [iconColor]="iconColor"
    [externalLink]="oneViewLink()"
></syn-avatar>
